const today = () => new Date().toISOString().split("T")[0];

export function buildProfessorClassicBlockSavePayload({ username, blockId, blockData, date = today() }) {
  return {
    username,
    date,
    [`bloc${blockId}`]: blockData,
  };
}
